module.exports = __webpack_public_path__ + "static/media/2000.fcafdba7.png";